import React, { useState, useEffect } from "react"
import { connect } from "react-redux"
import { apiRequest } from "../data/redux/actions/api"
import { useGetFastTrackUserOnMount } from "../fast-track/hooks/useGetFastTrackUserOnMount"
import { CongratsTemplate } from "../common/templates/CongratsTemplate"
import FilledButtonM from "../common/components/button/FilledButtonM"
import { subscriptionService } from "../data/services/subscriptionService"
import { useApiStatus } from "../common/hooks/useApiStatus"
import { useNavigation } from "@react-navigation/native"
import ConstraintsGridStep from "../common/student-diagnostic-stepper/ConstraintsGridStep"
import { expandSlots, squashSlots } from "../data/utility/Utils"
import { IS_WEB } from "@common/utils/mobileUtils"

const NewSubscriberPossibleSlotsScreen = (props) => {
    const navigation = useNavigation()
    const { initialLoading, emailB64, email, user, subscriptionMetadata } =
        useGetFastTrackUserOnMount(props)
    
    const [selectedSlots, setSelectedSlots] = useState([])

    // Pre-select user's existing slots_possible when user data loads (expand squashed slots)
    useEffect(() => {
        if (user?.slots_possible && selectedSlots.length === 0) {
            setSelectedSlots(expandSlots(user.slots_possible))
        }
    }, [user?.slots_possible])

    const handleValidate = () => {
        // Squash slots before sending to backend
        const squashedSlots = squashSlots(selectedSlots)
        props.apiRequest(
            subscriptionService.updateSubscriptionPossibleSlots,
            {},
            { possible_slots: squashedSlots, email }
        )
    }
    useApiStatus(
        subscriptionService.updateSubscriptionPossibleSlots,
        null,
        true,
        () => {
            if (IS_WEB) {
                return navigation.navigate("subscribe/download-app", {
                    user: emailB64,
                })
            }
            return navigation.navigate("subscribe", {
                user: emailB64,
                status: "success",
            })
        }
    )

    const minSelectedSlots = props.sessionsPerWeek?.[
        subscriptionMetadata?.hours_per_month
    ] ?? 2

    const hasSelectedEnoughSlots = selectedSlots.length >= minSelectedSlots


    return (
        <CongratsTemplate
            isLoading={initialLoading}
            error={props.errorRetrieveUser}
            title="Merci, il ne vous reste plus qu'à choisir vos créneaux possibles"
            description={`Sélectionnez au minimum ${minSelectedSlots} créneaux pour votre planning personnalisé de cours`}
            bottomContent={
                <FilledButtonM
                    label={
                        hasSelectedEnoughSlots
                            ? "Valider"
                            : `Sélectionnez ${minSelectedSlots} créneaux minimum`
                    }
                    onPress={handleValidate}
                    disabled={!hasSelectedEnoughSlots}
                    loading={props.updateSubscriptionPossibleSlotsRequest}
                />
            }
        >
            <ConstraintsGridStep
                user={user}
                hoursPerWeek={
                    props.sessionsPerWeek?.[
                        subscriptionMetadata?.hours_per_month
                    ]
                }
                field={{
                    value: selectedSlots,
                    onChange: setSelectedSlots,
                }}
                includeSunday={subscriptionMetadata?.offer_type === "integral"}
            />
        </CongratsTemplate>
    )
}

const mapStateToProps = (state) => {
    return {
        sessionsPerWeek: state.data.formData?.sessionsPerWeek,
        errorRetrieveUser: state.api.getSubscribePricing?.error,
        updateSubscriptionPossibleSlotsRequest: state.api.updateSubscriptionPossibleSlots?.request,
    }
}

const mapDispatchToProps = {
    apiRequest,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NewSubscriberPossibleSlotsScreen)
